import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useState, useEffect, useRef } from 'preact/hooks'

import NoResults from '../serp/NoResults'
import Products from '../serp/Products'
import Toolbar from '../serp/Toolbar'
import Sidebar from '../serp/Sidebar'
import BottomToolbar from '../serp/BottomToolbar'
import Loader from '../serp/Loader'
import SelectedFilters from '../serp/SelectedFilters'

import { checkReviews, removeEmptyElements } from "../../helpers"

export default () => {
    const { response: { products }, loading } = useAppState()
    const foundProducts = products && products.total > 0

    const [showFilters, setShowFilters] = useState(false)
    const [selectedItems, setSelectedItems] = useState([]);
    const [clickedFacet, setClickedFacet] = useState(null);

    const handleClickFilters = (facet = null) => {
        setShowFilters(!showFilters)
        setClickedFacet(facet)
    }

    // useEffect(() => {
    //     if (!loading) {
    //         checkReviews().then(() => {
    //             setTimeout(() => removeEmptyElements(), 1000)
    //         });
    //     }
    // }, [loading])

    useEffect(() => {
        if (!loading) {
            setTimeout(() => {
                checkReviews()
            }, 1500);
        }
    }, [loading])


    // SHOPLIFT CRO TEST STICKY TOOLBAR (WRIKE TICKET ID 1737640999)
    const enableStickyFilters = true;

    if (enableStickyFilters) {
        return (
            <div>
                {foundProducts && 
                    <>
                        <div className="ns-serp ns-font-inherit ns-p-4 ns-my-0 ns-mx-auto collection-toolbar-wrapper">
                            <Toolbar
                                mobile
                                showFilters={showFilters}
                                setShowFilters={setShowFilters}
                                handleClickFilters={handleClickFilters}
                                selectedItems={selectedItems}
                                setSelectedItems={setSelectedItems}
                            />

                            <Toolbar
                                showFilters={showFilters}
                                setShowFilters={setShowFilters}
                                handleClickFilters={handleClickFilters}
                                selectedItems={selectedItems}
                                setSelectedItems={setSelectedItems}
                                setClickedFacet={setClickedFacet}
                            />
                        </div>
                    </>
                }

                <div class="ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-p-4 ns-my-0 ns-mx-auto">
                    <div class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0">
                        {foundProducts ? (
                            <>
                                <div style="display: flex">
                                    <Sidebar
                                        showFilters={showFilters}
                                        setShowFilters={setShowFilters}
                                        selectedItems={selectedItems}
                                        setSelectedItems={setSelectedItems} 
                                        clickedFacet={clickedFacet}
                                        setClickedFacet={setClickedFacet}
                                    />
                                    <Products />
                                </div>
                                <BottomToolbar />
                            </>
                        ) : loading ? (
                            <Loader />
                        ) : (
                            <NoResults />
                        )}
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div class="ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-p-4 ns-my-0 ns-mx-auto" style="min-height: 890px;">
                {(foundProducts || (loading && foundProducts)) && <Fragment>
                    {/* <Sidebar
                        selectedItems={selectedItems}
                        setSelectedItems={setSelectedItems} /> */}
                    <Toolbar
                        mobile
                        showFilters={showFilters}
                        setShowFilters={setShowFilters}
                        handleClickFilters={handleClickFilters}
                        selectedItems={selectedItems}
                        setSelectedItems={setSelectedItems}
                    />
                </Fragment>
                }
                <div class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0 ns-pl-md-5">
                    {foundProducts ? (
                        <>
                            <Toolbar
                                showFilters={showFilters}
                                setShowFilters={setShowFilters}
                                handleClickFilters={handleClickFilters}
                                selectedItems={selectedItems}
                                setSelectedItems={setSelectedItems}
                                setClickedFacet={setClickedFacet}
                            />
                            {/* <Loader /> */}
                            <div style="display: flex">
                                <Sidebar
                                    showFilters={showFilters}
                                    setShowFilters={setShowFilters}
                                    selectedItems={selectedItems}
                                    setSelectedItems={setSelectedItems} 
                                    clickedFacet={clickedFacet}
                                    setClickedFacet={setClickedFacet}
                                />
                                <Products />
                            </div>
                            <BottomToolbar />
                        </>
                    ) : loading ? (
                        <Loader />
                    // ) : foundProducts ? (
                    //     <>
                    //         <Toolbar
                    //             showFilters={showFilters}
                    //             setShowFilters={setShowFilters}
                    //             handleClickFilters={handleClickFilters}
                    //             selectedItems={selectedItems}
                    //             setSelectedItems={setSelectedItems}
                    //         />
                    //         <div style="display: flex">
                    //             <Sidebar
                    //                 showFilters={showFilters}
                    //                 setShowFilters={setShowFilters}
                    //                 selectedItems={selectedItems}
                    //                 setSelectedItems={setSelectedItems} />
                    //             <Products />
                    //         </div>
                    //         <BottomToolbar />
                    //     </>
                    ) : (
                        <NoResults />
                    )}
                </div>
            </div>
        )
    }
}
